import gql from 'graphql-tag';
export const ExplorationDataFragment = gql`
  fragment ExplorationDataFragment on ExplorationData {
    explorationId
    name
    description
    labels
    parameters {
      key
      modelId
    }
    view {
      canvas
      cells {
        ... on RecordsViewCell {
          id
          kind
          title
          excludeProperties
          pipeline {
            baseModelId
            operations {
              operation
              parameters
              disabled
            }
            pipelineId
            parentId
          }
          sort {
            key
            direction
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
          }
          viewOptions
        }
        ... on FunnelViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            pipelineId
            operations {
              operation
              parameters
            }
          }
          viewOptions
        }
        ... on CohortViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
            parentId
          }
          viewOptions
        }
        ... on VariableViewCell {
          id
          kind
          definition
          viewOptions
        }
        ... on SqlViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
          }
          viewOptions
        }
        ... on PythonViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          viewOptions
        }
        ... on TextViewCell {
          id
          kind
          title
          content
          viewOptions
        }
        ... on ChatViewCell {
          id
          kind
          messages {
            id
            role
            type
            message
          }
          viewOptions
        }
        ... on ConversationViewCell {
          id
          kind
          conversationId
        }
      }
      options
    }
  }
`;
export const ConversationFragment = gql`
  fragment ConversationFragment on Conversation {
    conversationId
    messages {
      ... on ConversationTextMessage {
        id
        role
        type
        enabledSources
        research
        message
        jobId
      }
      ... on ConversationExplorationMessage {
        id
        role
        type
        jobId
        exploration {
          ...ExplorationDataFragment
        }
      }
    }
    jobs {
      jobId
      parentJobId
      channel
      createdAt
      progress {
        jobProgressId
        jobId
        status
        statusMessage
        createdAt
      }
    }
  }
  ${ExplorationDataFragment}
`;
export const ExplorationFragment = gql`
  fragment ExplorationFragment on Exploration {
    explorationId
    name
    description
    labels
    createdAt
    createdBy {
      email
    }
    updatedAt
    updatedBy {
      email
    }
    parameters {
      key
      modelId
    }
    view {
      canvas
      cells {
        ... on RecordsViewCell {
          id
          kind
          title
          excludeProperties
          pipeline {
            baseModelId
            operations {
              operation
              parameters
              disabled
            }
            pipelineId
            parentId
          }
          sort {
            key
            direction
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
          }
          viewOptions
        }
        ... on FunnelViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            pipelineId
            operations {
              operation
              parameters
            }
          }
          viewOptions
        }
        ... on CohortViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
            parentId
          }
          viewOptions
        }
        ... on VariableViewCell {
          id
          kind
          definition
          viewOptions
        }
        ... on SqlViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
          }
          viewOptions
        }
        ... on PythonViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          viewOptions
        }
        ... on TextViewCell {
          id
          kind
          title
          content
          viewOptions
        }
        ... on ChatViewCell {
          id
          kind
          messages {
            id
            role
            type
            message
          }
          viewOptions
        }
        ... on ConversationViewCell {
          id
          kind
          conversationId
        }
      }
      options
    }
  }
`;
export const MetricFragment = gql`
  fragment MetricFragment on Metric {
    metricId
    name
    definition
  }
`;
export const ModelFragment = gql`
  fragment ModelFragment on Model {
    modelId
    name
    description
    primaryKey
    labels
    semantics
    properties {
      name
      type
      key
      format
      description
    }
    relations {
      key
      modelId
      type
      name
      joinStrategy {
        joinKeyOnBase
        joinKeyOnRelated
        through {
          modelId
          joinKeyToBase
          joinKeyToRelated
        }
        steps {
          relationKey
        }
      }
    }
  }
`;
export const RecordTypeFragment = gql`
  fragment RecordTypeFragment on QueryResponseRecordType {
    key
    type
    name
    pk
    precision
    model {
      modelId
      name
      propertyKey
    }
    relation {
      modelId
      key
      name
    }
  }
`;
export const AlertConfiguration = gql`
  query AlertConfiguration($accountId: ID!, $alertConfigurationId: ID!) {
    account(accountId: $accountId) {
      alertConfiguration(alertConfigurationId: $alertConfigurationId) {
        alertConfigurationId
        accountId
        name
        message
        pipeline
        keyFields
        excludedFields
        notificationConfig
        createdAt
      }
      models {
        modelId
        name
      }
    }
  }
`;
export const ExplorationRecordType = gql`
  query ExplorationRecordType(
    $accountId: ID!
    $baseModelId: ID!
    $pipeline: [OperationInput!]!
    $variables: JSON
  ) {
    account(accountId: $accountId) {
      accountId
      query(baseModelId: $baseModelId, pipeline: $pipeline, first: 1, variables: $variables) {
        recordType {
          key
          type
          name
          relation {
            modelId
            key
            name
          }
        }
        grouping {
          key
        }
      }
    }
  }
`;
export const Conversation = gql`
  query Conversation($accountId: ID!, $conversationId: ID!) {
    account(accountId: $accountId) {
      accountId
      conversation(conversationId: $conversationId) {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const StartConversation = gql`
  mutation StartConversation(
    $accountId: ID!
    $conversationId: ID!
    $message: ConversationMessageInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    startConversation(
      accountId: $accountId
      conversationId: $conversationId
      message: $message
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const AddMessage = gql`
  mutation AddMessage(
    $accountId: ID!
    $conversationId: ID!
    $message: ConversationMessageInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    addMessage(
      accountId: $accountId
      conversationId: $conversationId
      message: $message
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const UpdateMessage = gql`
  mutation UpdateMessage(
    $accountId: ID!
    $conversationId: ID!
    $message: ConversationMessageInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    updateMessage(
      accountId: $accountId
      conversationId: $conversationId
      message: $message
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const DiscardMessage = gql`
  mutation DiscardMessage($accountId: ID!, $conversationId: ID!, $messageId: ID!) {
    discardMessage(accountId: $accountId, conversationId: $conversationId, messageId: $messageId) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const DeleteMessage = gql`
  mutation DeleteMessage($accountId: ID!, $conversationId: ID!, $messageId: ID!) {
    deleteMessage(accountId: $accountId, conversationId: $conversationId, messageId: $messageId) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const CancelConversationJob = gql`
  mutation CancelConversationJob($accountId: ID!, $conversationId: ID!, $jobId: ID!) {
    cancelConversationJob(accountId: $accountId, conversationId: $conversationId, jobId: $jobId) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const RerunConversationJob = gql`
  mutation RerunConversationJob(
    $accountId: ID!
    $conversationId: ID!
    $jobId: ID!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    rerunConversationJob(
      accountId: $accountId
      conversationId: $conversationId
      jobId: $jobId
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragment}
`;
export const ExplorationGeneration = gql`
  query ExplorationGeneration(
    $accountId: ID!
    $search: String!
    $correlationId: String
    $exploration: ExplorationInput
  ) {
    account(accountId: $accountId) {
      generateExploration(
        search: $search
        correlationId: $correlationId
        exploration: $exploration
      ) {
        exploration {
          ...ExplorationDataFragment
        }
      }
    }
  }
  ${ExplorationDataFragment}
`;
export const ExplorationsSearch = gql`
  query ExplorationsSearch($accountId: ID!, $search: String!) {
    account(accountId: $accountId) {
      explorationSearch(search: $search) {
        ...ExplorationDataFragment
      }
    }
  }
  ${ExplorationDataFragment}
`;
export const DeleteExploration = gql`
  mutation DeleteExploration($accountId: ID!, $explorationId: ID!) {
    deleteExploration(accountId: $accountId, explorationId: $explorationId) {
      ... on DeleteExplorationSuccess {
        result
      }
      ... on NotAllowedError {
        message
      }
    }
  }
`;
export const EnumOptions = gql`
  query EnumOptions($accountId: ID!, $modelId: ID!, $propertyKey: String!) {
    account(accountId: $accountId) {
      accountId
      model(modelId: $modelId) {
        modelId
        property(key: $propertyKey) {
          key
          enumOptions {
            label
            value
          }
        }
      }
    }
  }
`;
export const ExplorationChat = gql`
  subscription ExplorationChat(
    $accountId: ID!
    $conversation: ConversationInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    ask(
      accountId: $accountId
      conversation: $conversation
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      lastMessage {
        ... on ConversationTextMessage {
          id
          role
          type
          message
        }
        ... on ConversationExplorationMessage {
          id
          role
          type
          exploration {
            ...ExplorationDataFragment
          }
        }
      }
    }
  }
  ${ExplorationDataFragment}
`;
export const ExplorationData = gql`
  query ExplorationData(
    $accountId: ID!
    $baseModelId: ID!
    $pipeline: [OperationInput!]!
    $first: Int
    $after: String
    $sort: [QuerySortBy!]
    $variables: JSON
    $options: QueryOptionsInput
  ) {
    account(accountId: $accountId) {
      accountId
      name
      query(
        baseModelId: $baseModelId
        pipeline: $pipeline
        first: $first
        after: $after
        sort: $sort
        variables: $variables
        options: $options
      ) {
        edges {
          node
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        recordType {
          ...RecordTypeFragment
        }
        grouping {
          key
        }
      }
    }
  }
  ${RecordTypeFragment}
`;
export const ExplorationDescribeQuery = gql`
  query ExplorationDescribeQuery(
    $accountId: ID!
    $baseModelId: ID!
    $pipeline: [OperationInput!]!
    $first: Int
    $after: String
    $sort: [QuerySortBy!]
    $variables: JSON
    $options: QueryOptionsInput
  ) {
    account(accountId: $accountId) {
      accountId
      name
      describeQuery(
        baseModelId: $baseModelId
        pipeline: $pipeline
        first: $first
        after: $after
        sort: $sort
        variables: $variables
        options: $options
      ) {
        sql
      }
    }
  }
`;
export const UpsertExploration = gql`
  mutation UpsertExploration($accountId: ID!, $input: ExplorationInput!) {
    upsertExploration(accountId: $accountId, input: $input) {
      ...ExplorationFragment
    }
  }
  ${ExplorationFragment}
`;
export const Explorations = gql`
  query Explorations($accountId: ID!) {
    account(accountId: $accountId) {
      accountId
      explorations {
        ...ExplorationFragment
      }
      models {
        ...ModelFragment
      }
      metrics {
        ...MetricFragment
      }
      parameterisedExplorations {
        ...ExplorationFragment
      }
    }
  }
  ${ExplorationFragment}
  ${ModelFragment}
  ${MetricFragment}
`;
export const GetExplorationState = gql`
  query GetExplorationState($accountId: ID!, $explorationId: ID!) {
    account(accountId: $accountId) {
      explorationState(explorationId: $explorationId) {
        explorationId
        previousStateId
        explorationSourceId
        state
      }
    }
  }
`;
export const SetExplorationState = gql`
  mutation SetExplorationState($accountId: ID!, $input: ExplorationStateInput!) {
    upsertExplorationState(accountId: $accountId, input: $input) {
      explorationId
      previousStateId
      explorationSourceId
      state
    }
  }
`;
export const AccountsList = gql`
  query AccountsList {
    me {
      userId
      email
    }
    accounts {
      accountId
      slug
      name
      timezone
      isOnboarded
      features
      me {
        role {
          permissions {
            permissionId
          }
        }
      }
    }
  }
`;
export const CreateAnalyticsEvent = gql`
  mutation CreateAnalyticsEvent($input: CreateAnalyticsEventInput!, $accountId: ID) {
    createAnalyticsEvent(input: $input, accountId: $accountId) {
      ... on AnalyticsEvent {
        analyticsEventId
      }
      ... on NotAllowedError {
        message
      }
      ... on CreateAnalyticsEventError {
        error
      }
    }
  }
`;
export const OnboardingState = gql`
  query OnboardingState($accountId: ID!) {
    account(accountId: $accountId) {
      onboardingState {
        hasConnection
        hasConsented
        hasOnboarded
        hasPassedSetupCallStep
        hasBookedSetupCall
        welcomeSurvey
      }
    }
  }
`;
export const CreateConnection = gql`
  mutation CreateConnection($accountId: ID!, $type: String!, $name: String!, $properties: JSON!) {
    createConnection(accountId: $accountId, type: $type, name: $name, properties: $properties) {
      connectionId
    }
  }
`;
export const TestConnection = gql`
  query TestConnection($accountId: ID!, $type: String!, $properties: JSON!) {
    account(accountId: $accountId) {
      testConnection(type: $type, properties: $properties) {
        ... on TestConnectionSuccess {
          success
        }
        ... on TestConnectionFailed {
          error
        }
      }
    }
  }
`;
export const GiveConsent = gql`
  mutation GiveConsent($accountId: ID!, $input: ConsentInput!) {
    giveConsent(accountId: $accountId, input: $input)
  }
`;
export const UpdateOnboardingState = gql`
  mutation UpdateOnboardingState($accountId: ID!, $key: OnboardingStateKey!, $value: JSON!) {
    updateOnboardingState(accountId: $accountId, key: $key, value: $value)
  }
`;
export const SignUp = gql`
  mutation SignUp($email: String!, $consent: ConsentInput!) {
    signUp(email: $email, consent: $consent) {
      userId
    }
  }
`;
export const CreateAccessToken = gql`
  mutation CreateAccessToken($input: CreateAccessTokenInput!) {
    createAccessToken(input: $input) {
      ... on AccessTokenPreview {
        accessToken {
          name
          preview
          lastUsedAt
          expiresAt
          createdAt
          accessTokenId
        }
        token
      }
      ... on NotAllowedError {
        message
      }
      ... on CreateAccessTokenError {
        error
      }
    }
  }
`;
export const DeleteAccessToken = gql`
  mutation DeleteAccessToken($accessTokenId: ID!) {
    deleteAccessToken(accessTokenId: $accessTokenId) {
      ... on DeleteAccessTokenSuccess {
        result
      }
      ... on NotAllowedError {
        message
      }
      ... on DeleteAccessTokenError {
        error
      }
    }
  }
`;
export const UpdateAiBusinessConcepts = gql`
  mutation UpdateAiBusinessConcepts($accountId: ID!, $aiBusinessConcepts: String!) {
    updateAiBusinessConcepts(accountId: $accountId, aiBusinessConcepts: $aiBusinessConcepts) {
      accountId
      aiBusinessConcepts
    }
  }
`;
export const UpsertAiSystemInstruction = gql`
  mutation UpsertAiSystemInstruction(
    $accountId: ID!
    $connectionId: ID
    $integrationId: ID
    $instructions: String
  ) {
    upsertAiSystemInstruction(
      accountId: $accountId
      connectionId: $connectionId
      integrationId: $integrationId
      instructions: $instructions
    ) {
      aiSystemInstructionId
      source
      instructions
      connectionId
      integrationId
    }
  }
`;
export const DeleteAlertConfiguration = gql`
  mutation DeleteAlertConfiguration($accountId: ID!, $alertConfigurationId: ID!) {
    deleteAlertConfiguration(accountId: $accountId, alertConfigurationId: $alertConfigurationId) {
      ... on DeleteAlertConfigurationSuccess {
        result
      }
    }
  }
`;
export const UpsertAlertConfiguration = gql`
  mutation UpsertAlertConfiguration($accountId: ID!, $input: AlertConfigurationInput!) {
    upsertAlertConfiguration(accountId: $accountId, input: $input) {
      alertConfigurationId
      name
      message
      keyFields
      pipeline
      notificationConfig
      createdAt
    }
  }
`;
export const AccountSettings = gql`
  query AccountSettings($accountId: ID!) {
    accessTokens {
      name
      preview
      expiresAt
      lastUsedAt
      createdAt
      accessTokenId
    }
    account(accountId: $accountId) {
      accountId
      name
      me {
        userId
        role {
          roleId
          permissions {
            permissionId
          }
        }
      }
      users {
        userId
        email
        role {
          roleId
          name
        }
        addedAt
      }
      connections {
        connectionId
        name
        type
        createdAt
      }
      integrations {
        integrationId
        service
        name
        workspaceId
        url
        description
        createdAt
      }
      alertConfigurations {
        alertConfigurationId
        accountId
        name
        message
        keyFields
        excludedFields
        pipeline
        notificationConfig
        createdAt
      }
      models {
        ...ModelFragment
      }
      metrics {
        ...MetricFragment
      }
      navigation {
        ... on ExplorationNavigationItem {
          kind
          label
          explorationId
        }
      }
      explorations {
        explorationId
        name
      }
      aiBusinessConcepts
      aiSystemInstructions {
        aiSystemInstructionId
        source
        instructions
        connectionId
        integrationId
      }
    }
  }
  ${ModelFragment}
  ${MetricFragment}
`;
export const CreateGoogleDriveIntegration = gql`
  mutation CreateGoogleDriveIntegration($url: String!, $accountId: String!) {
    createGoogleDriveIntegration(folderUrl: $url, accountId: $accountId) {
      success
    }
  }
`;
export const CreateNotionIntegration = gql`
  mutation CreateNotionIntegration($apiKey: String!, $accountId: String!) {
    createNotionIntegration(apiKey: $apiKey, accountId: $accountId) {
      success
    }
  }
`;
export const OauthSlackCallback = gql`
  mutation OauthSlackCallback($code: String!, $redirectUri: String!, $accountId: String!) {
    oauthSlackCallback(code: $code, redirectUri: $redirectUri, accountId: $accountId) {
      ... on OauthSlackCallbackSuccess {
        success
      }
      ... on OauthSlackCallbackError {
        error
      }
    }
  }
`;
export const UpdateNavigation = gql`
  mutation UpdateNavigation($accountId: ID!, $input: JSON!) {
    updateNavigation(accountId: $accountId, input: $input)
  }
`;
export const AddUserToAccount = gql`
  mutation AddUserToAccount($accountId: ID!, $email: String!, $role: UserRole!) {
    addUserToAccount(accountId: $accountId, email: $email, role: $role) {
      accountUser {
        userId
        email
        role {
          roleId
        }
      }
    }
  }
`;
export const DeleteUserFromAccount = gql`
  mutation DeleteUserFromAccount($accountId: ID!, $userId: ID!) {
    deleteUserFromAccount(accountId: $accountId, userId: $userId) {
      account {
        accountId
        users {
          userId
          email
          role {
            roleId
          }
          addedAt
        }
      }
      accountUser {
        userId
        email
      }
      success
    }
  }
`;
export const UpdateUserInAccount = gql`
  mutation UpdateUserInAccount($accountId: ID!, $userId: ID!, $role: UserRole!) {
    updateUserInAccount(accountId: $accountId, userId: $userId, role: $role) {
      accountUser {
        userId
        email
      }
    }
  }
`;
export const Workspace = gql`
  query Workspace {
    me {
      userId
      email
    }
    accounts {
      accountId
      slug
      name
      timezone
      isOnboarded
      features
      pinnedExplorationIds
      integrations {
        integrationId
        service
        name
        description
        createdAt
      }
      me {
        role {
          permissions {
            permissionId
          }
        }
      }
    }
  }
`;
